var exports = {
  "D": "xcc377c0b--7fb889--title",
  "Q": "xcc377c0b--7fb889--content",
};

module.exports = exports;
